import { render, staticRenderFns } from "./businessName.vue?vue&type=template&id=2086454c&scoped=true&"
import script from "./businessName.vue?vue&type=script&lang=js&"
export * from "./businessName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2086454c",
  null
  
)

export default component.exports